import { FORM_ERROR } from 'final-form';
import { prop } from 'ramda';
import { useCallback } from 'react';
import { useUserSelector } from 'js/store/hooks';
import { useHandleActions } from 'js/components/system/App/hooks';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { FUND_TRANSFER_TYPE_DEPOSIT, FUND_TRANSFER_TYPE_WITHDRAW } from '../constants';
import * as server from '../server';

export const useOnSubmit = ({ fetchExternalBalance }) => {
    const translate = useComponentTranslations();
    const currencyCode = useUserSelector(prop('currencyCode'));
    const handleActions = useHandleActions();

    return useCallback(async ({ type, amount, pin }, form) => {
        try {
            switch (type) {
                case FUND_TRANSFER_TYPE_DEPOSIT: {
                    const response = await server.deposit({ amount, currencyCode, pin });
                    const { actions } = response.data;

                    await handleActions(actions);
                    break;
                }

                case FUND_TRANSFER_TYPE_WITHDRAW: {
                    const response = await server.withdraw({ amount, currencyCode, pin });
                    const { actions } = response.data;

                    await handleActions(actions);
                    break;
                }

                default:
                // noop
            }

            // reset form back to initial values and state
            setImmediate(() => form.restart());

            await fetchExternalBalance();
        } catch (error) {
            const defaultMessage = error?.response?.data?.errorMessage || 'playtech.mobile.system.error.default';

            return {
                [FORM_ERROR]: translate(`${type}.error.${error?.response?.data?.errorCode}`, defaultMessage)
            };
        }
    }, [
        translate,
        currencyCode,
        handleActions,
        fetchExternalBalance
    ]);
};
